import { render, staticRenderFns } from "./reportCenterTable.vue?vue&type=template&id=3f1fcb5a&scoped=true&"
import script from "./reportCenterTable.vue?vue&type=script&lang=js&"
export * from "./reportCenterTable.vue?vue&type=script&lang=js&"
import style0 from "./reportCenterTable.vue?vue&type=style&index=0&id=3f1fcb5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1fcb5a",
  null
  
)

export default component.exports